module.exports = __webpack_public_path__ + "de45d67842d727c88ff23657e10bfc02.MP3";